import React, { Component } from 'react';
import { connect } from 'react-redux';
import { mapaTiposAssentosCategorias, tipoCategoria } from '../../util/constantsUtil';

export class MapaVeiculoCategoriaPoltrona extends Component {
    constructor(props) {
        super(props);       
    }

    marcarPoltrona(fileira, assento) {
        if (this.props.marcarPoltrona) {
            this.props.marcarPoltrona(fileira, assento);
        }
    }

    // eslint-disable-next-line class-methods-use-this
    exibirCorredor(fileira) {
        return (fileira.exibeCorredor ? <div className="transport-meio-corredor" key={`corredor-${fileira.numero}`} /> : '')
    }

    // eslint-disable-next-line class-methods-use-this
    exibirFileira(fileira) {
        if (fileira.assentos.length > 0) {
            return (
                <div className="transport-meio-fileira" key={`fileira-${fileira.numero}-${this.props.andar}`}>
                    {this.exibirAssentos(fileira)}
                    <label htmlFor="_" className="transport-meio-assento espaco-vago" key='meio6'>_</label>
                </div>
            )
        }
    }

    definirCorBackgroundParaPoltronasMarcadas(fileira, assento) {
        return this.props.listaCategoriasPoltronas 
            && this.props.listaCategoriasPoltronas.filter(it => it.fileira.id === fileira.id && it.assento.id === assento.id && it.assento.numero === assento.numero).length > 0 
                ? mapaTiposAssentosCategorias.get( this.props.listaCategoriasPoltronas.filter(it => it.assento.id === assento.id)[0].tipoPreco ).cor : '';
    }

    definirCorNumeroPoltronasMarcadas(fileira, assento) {
        return this.props.listaCategoriasPoltronas 
            && this.props.listaCategoriasPoltronas.filter(it => it.assento.id === assento.id && it.assento.numero === assento.numero).length > 0 
            ? mapaTiposAssentosCategorias.get( this.props.listaCategoriasPoltronas.filter(it => it.assento.id === assento.id)[0].tipoPreco ).textColor : '';
    }

    exibirAssentos(fileira) {
        return fileira.assentos.map(assento => <div key={`assento-${this.props.andar}-${fileira.numero}-${assento.ordem}`}
                    onClick={() => this.marcarPoltrona(fileira, assento)}>
            <label className={assento.tipoAssento === 'NORMAL' ? 'assento assento-disponivel  js-seat-selected-amplitude' : 'espaco-vago  js-seat-selected-amplitude'}
             style={{
                backgroundColor: this.definirCorBackgroundParaPoltronasMarcadas(fileira, assento),
                color:  this.definirCorNumeroPoltronasMarcadas(fileira, assento)
              }}>
                {assento.numero}
            </label>
        </div>)
    }

    exibirMapaVeiculo() {
        const mapaVeiculo = this.props.veiculoSelecionado.value.mapaVeiculoDto;

        if (mapaVeiculo && (mapaVeiculo.fileirasPrimeiroAndar || mapaVeiculo.fileirasSegundoAndar)) {
            const fileiras = this.props.andarSelecionado === 1 ? mapaVeiculo.fileirasPrimeiroAndar : mapaVeiculo.fileirasSegundoAndar;

            return (fileiras.map(fileira => <React.Fragment key={fileira.id}>
                <div>
                    {this.exibirFileira(fileira)}
                </div>
                {this.exibirCorredor(fileira)}
            </React.Fragment>))
        }
    }

    exibirMapaVeiculoEdicaoItinerario() {        
        const mapaVeiculo = this.props.itinerarioSelecionado.veiculoDto.mapaVeiculoDto;

        if (mapaVeiculo && (mapaVeiculo.fileirasPrimeiroAndar || mapaVeiculo.fileirasSegundoAndar)) {                
            const fileiras = this.props.itinerarioSelecionado.andar === 1 ? mapaVeiculo.fileirasPrimeiroAndar : mapaVeiculo.fileirasSegundoAndar;

            return (fileiras.map(fileira => <React.Fragment key={fileira.id}>
                <div>
                    {this.exibirFileira(fileira)}
                </div>
                {this.exibirCorredor(fileira)}
            </React.Fragment>))
        }
        
    }

    verificarEdicaoModalTipoCategoria() {
        return (this.props.idItinerario
            && this.props.itinerarioSelecionado.tipoCategoria == tipoCategoria.mista.valor)
            || (this.props.idItinerario && !this.props.exibeTipoCategoriaUnica);            
    }

    handleAndarSelecionado(andarSelecionado) {
        this.props.verificarAndarSelecionado(andarSelecionado);
    }

    // eslint-disable-next-line class-methods-use-this
    exibirAcoes() {
        if (this.props.veiculoSelecionado && this.props.veiculoSelecionado.value) {            
            const mapaVeiculo = this.props.veiculoSelecionado.value.mapaVeiculoDto;

            if (mapaVeiculo && mapaVeiculo.seDoisAndares) {
                return !this.props.idItinerario && <div className="card" style={{
                    width: '8rem'
                }}>
                    <ul className="list-group list-group-flush">
                        <li key='primeiro-andar' onClick={() => this.handleAndarSelecionado(1)} className="list-group-item" style={{
                            cursor: 'pointer',
                            backgroundColor: this.props.andarSelecionado === 1 ? '#fa8d42' : ''
                        }}><span className='ml-2'>1° andar</span></li>
                        <li key='segundo-andar' onClick={() => this.handleAndarSelecionado(2)} className="list-group-item" style={{
                            cursor: 'pointer',
                            backgroundColor: this.props.andarSelecionado === 2 ? '#fa8d42' : ''
                        }}><span className='ml-2'>2° andar</span></li>
                    </ul>
                </div>
            }
        }
    }

    render() {
        return (
            <React.Fragment>
                <div className='card' style={{ overflow: 'auto' }}>
                    {this.exibirAcoes()}
                    <div className='row d-flex justify-content-center col-12'>
                    </div>
                    <div className="transport-result-wrapper transport-result-wrapper-connection " data-wrapper-direction="">
                        <div className="js-count-transport">
                            <div className="transport bus-design bus-design-side ">
                                <div className="transport-frente" />
                                <div className="transport-meio transport-meio-thin">
                                    {this.verificarEdicaoModalTipoCategoria() ? this.exibirMapaVeiculoEdicaoItinerario() : this.exibirMapaVeiculo()}
                                </div>
                                <div className="transport-traseira" />
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export function mapStateToProps(state) {
    return {
        veiculos: state.veiculos.veiculos,
        veiculoSelecionado: state.veiculoItinerarioSelecionado,
        itinerarioSelecionado: state.itinerarioSelecionado,
    }
}

export default connect(mapStateToProps, {})(MapaVeiculoCategoriaPoltrona)